import React from 'react';
import { Square } from '@grubhubprod/gh-cookbook-react';
import { CorporateLogo } from 'src/components/common/CorporateLogo/CorporateLogo';
import { useScreenSizes } from 'src/utilities/useScreenSizes';

export const LogoHeader: React.FC = () => {
  const { isPhone } = useScreenSizes();
  return (
    <Square inset="lg" as="header" position="absolute">
      <CorporateLogo
        logo={isPhone ? 'grubhubCorporateLogo' : 'grubhubCorporateLogoWhite'}
      />
    </Square>
  );
};
